// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"summary","fill":"props.strokeColor1","d":"M18.002 19.7324L16.3506 22H15.3467L16.3291 19.8574H15V17H18.002V19.7324ZM22 19.7324L20.3486 22H19.3457L20.3281 19.8574H19V17H22V19.7324ZM13 20H2V18H13V20ZM22 13H2V11H22V13ZM3.67188 4.14258H5V7H2V4.26758L3.65137 2H4.6543L3.67188 4.14258ZM7.6709 4.14258H9V7H5.99805V4.26758L7.64941 2H8.65332L7.6709 4.14258ZM22 6H11V4H22V6Z"}}]};

const SummaryIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'summary',
    ref,
    icon: element,
  },
));

SummaryIcon.displayName = 'SummaryIcon';

export default SummaryIcon;
